import { FeedbackPerfil } from "#/containers/Feedback/pages/PerfilNaoAtendido/enums";

const PAGINAS_OFERTAS = {
  ROOT: () => "/ofertas",
  COBERTURAS: (plano: string) =>
    `${PAGINAS_OFERTAS.ROOT()}/coberturas/${plano}`,
  ASSISTENCIAS: (plano: string) =>
    `${PAGINAS_OFERTAS.ROOT()}/assistencias/${plano}`,
  VIDROS: (plano: string) => `${PAGINAS_OFERTAS.ROOT()}/vidros/${plano}`,
};

const PAGINAS_EFETIVACAO = {
  ROOT: () => "/efetivacao",
  CEP: () => `${PAGINAS_EFETIVACAO.ROOT()}/cep`,
  DADOS_COMPLEMENTARES: () =>
    `${PAGINAS_EFETIVACAO.ROOT()}/dados-complementares`,
  FORMA_DE_PAGAMENTO: () => `${PAGINAS_EFETIVACAO.ROOT()}/forma-de-pagamento`,
  CONTA_DE_PAGAMENTO: () => `${PAGINAS_EFETIVACAO.ROOT()}/conta-de-pagamento`,
  RESUMO: () => `${PAGINAS_EFETIVACAO.ROOT()}/resumo`,
};

const PAGINAS_SIMULACAO = {
  ROOT: () => "/simulacao",
  DADOS_PESSOAIS: () => `${PAGINAS_SIMULACAO.ROOT()}/dados-pessoais`,
  PERNOITE: () => `${PAGINAS_SIMULACAO.ROOT()}/pernoite`,
  VEICULO: () => `${PAGINAS_SIMULACAO.ROOT()}/veiculo`,
  VEICULO_MODELOS: () => `${PAGINAS_SIMULACAO.VEICULO()}/modelos`,
  VEICULO_DADOS_MODELO: () => `${PAGINAS_SIMULACAO.VEICULO()}/dados-modelo`,
  DADOS_SEGURO: () => `${PAGINAS_SIMULACAO.ROOT()}/dados-seguro`,
  DADOS_SEGURO_BASICO: () => `${PAGINAS_SIMULACAO.DADOS_SEGURO()}/basico`,
  DADOS_SEGURO_UTILIZACAO: () =>
    `${PAGINAS_SIMULACAO.DADOS_SEGURO()}/utilizacao`,
  DADOS_RENOVACAO: () => `${PAGINAS_SIMULACAO.ROOT()}/dados-renovacao`,
  DADOS_RENOVACAO_INFO: () =>
    `${PAGINAS_SIMULACAO.DADOS_RENOVACAO()}/informacoes`,
};

const PAGINAS_FEEDBACK = {
  ROOT: () => "/feedback",
  ERRO: () => `${PAGINAS_FEEDBACK.ROOT()}/erro`,
  PERFIL: () => `${PAGINAS_FEEDBACK.ROOT()}/perfil/`,
  PERFIL_PARAMS: (params: string) => `${PAGINAS_FEEDBACK.PERFIL()}${params}`,
  PERFIL_SICREDIX: () =>
    `${PAGINAS_FEEDBACK.PERFIL()}${FeedbackPerfil.SICREDIX}`,
  PERFIL_RESIDENTES: () =>
    `${PAGINAS_FEEDBACK.PERFIL()}${FeedbackPerfil.FAIXA_IDADE}`,
  VEICULO_BUSCA_MODELOS: () =>
    `${PAGINAS_FEEDBACK.ROOT()}/busca-modelos-veiculos`,
  VEICULO_SEM_MODELO: () => `${PAGINAS_FEEDBACK.ROOT()}/sem-modelo-veiculo`,
  PROPOSTA_ENVIADA: (vistoria: string) =>
    `${PAGINAS_FEEDBACK.ROOT()}/proposta-enviada/${vistoria}`,
};

const PAGINAS_RECUPERACAO = {
  ROOT: () => "/lista-cotacoes",
  DETALHE: (numeroCotacao: string) =>
    `${PAGINAS_RECUPERACAO.ROOT()}/detalhes-cotacao/${numeroCotacao}`,
};

const PAGINAS_ACOMPANHAMENTO = {
  ROOT: () => "/acompanhamento-proposta",
};

export const PAGINAS = {
  ROOT: () => "/",
  ONBOARDING: () => "/onboarding",
  RECUPERACAO: PAGINAS_RECUPERACAO,
  ACOMPANHAMENTO: PAGINAS_ACOMPANHAMENTO,
  SIMULACAO: PAGINAS_SIMULACAO,
  OFERTAS: PAGINAS_OFERTAS,
  FEEDBACK: PAGINAS_FEEDBACK,
  EFETIVACAO: PAGINAS_EFETIVACAO,
};
